// All illustrative DEMO data for MFDX. Clearly labelled as demo across the UI.
const U = (id, w = 800) => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=${w}`;
export const KPIS = {
  totalAUM: "₹78.4 Cr", equityAUM: "₹46.2 Cr", debtAUM: "₹22.1 Cr", hybridAUM: "₹10.1 Cr",
  sipBook: "₹42.6 L/mo", grossSales: "₹3.1 Cr", redemptions: "₹1.4 Cr", netSales: "₹1.7 Cr",
  folios: "1,284", activeClients: "420", newClients: "18", revenue: "₹6.9 L/mo",
  brokerage: "₹5.2 L", trail: "₹4.1 L", avgClientAUM: "₹18.6 L",
};
export const GROWTH = { aum: 7.2, clients: 4.3, sip: 6.1, revenue: 5.8 };

export const AUM_TREND = [
  { m: "Feb", aum: 61, sip: 34 }, { m: "Mar", aum: 64, sip: 36 }, { m: "Apr", aum: 63, sip: 37 },
  { m: "May", aum: 68, sip: 39 }, { m: "Jun", aum: 71, sip: 40 }, { m: "Jul", aum: 74, sip: 41 },
  { m: "Aug", aum: 78, sip: 43 },
];
export const CATEGORY_MIX = [
  { name: "Equity", value: 46, color: "#3B82F6" }, { name: "Debt", value: 22, color: "#8B5CF6" },
  { name: "Hybrid", value: 10, color: "#F97316" }, { name: "Others", value: 22, color: "#A3E635" },
];
export const CLIENT_INTEL = [
  { label: "Clients at risk", value: 12, tone: "coral" }, { label: "Dormant clients", value: 23, tone: "amber" },
  { label: "High-value clients", value: 34, tone: "blue" }, { label: "SIP stoppages", value: 7, tone: "coral" },
  { label: "Redemption alerts", value: 4, tone: "amber" }, { label: "Cross-sell opps", value: 19, tone: "lime" },
];
export const AI_CARDS = [
  { tag: "MARKET", icon: "TrendingUp", color: "blue", text: "Nifty is up 0.7% today, led by IT and Banking." },
  { tag: "BUSINESS", icon: "Wallet", color: "violet", text: "Your AUM increased ₹32 lakh this week." },
  { tag: "CLIENTS", icon: "Users", color: "coral", text: "7 clients need follow-up today." },
  { tag: "COMPLIANCE", icon: "ShieldCheck", color: "lime", text: "1 new AMFI update requires your attention." },
  { tag: "MARKETING", icon: "Megaphone", color: "cyan", text: "Your LinkedIn post generated 1,240 views." },
  { tag: "OPPORTUNITY", icon: "Target", color: "violet", text: "23 dormant clients ≈ ₹1.8 Cr AUM to re-activate." },
];
export const TODAY = {
  todo: ["Call 5 SIP clients flagged by AI", "Publish today's market update post", "Review Sneha Patil's ₹50L proposal"],
  followups: ["Rajesh Sharma — SIP stopped 45 days ago", "Kavita Joshi — ELSS interest"],
  regulatory: "SEBI circular on nomination — deadline 28 Aug 2026",
  contentIdeas: ["SIP vs lumpsum reel", "Festival greeting creative", "Why markets fell — explainer"],
};

export const NAV = [
  { key: "dashboard", label: "Dashboard", icon: "LayoutDashboard", path: "/app/dashboard" },
  { key: "clients", label: "My Clients", icon: "UserSquare2", path: "/app/clients" },
  { key: "leads", label: "Leads", icon: "Target", path: "/app/leads" },
  { key: "tasks", label: "Tasks", icon: "ListChecks", path: "/app/tasks" },
  { key: "ai", label: "MFDX AI Copilot", icon: "Sparkles", path: "/app/ai" },
  { key: "business", label: "My Business", icon: "BarChart3", path: "/app/business" },
  { key: "crm", label: "CRM Pipeline", icon: "Users", path: "/app/crm" },
  { key: "marketing", label: "Marketing", icon: "Megaphone", path: "/app/marketing" },
  { key: "content", label: "Content Studio", icon: "PenSquare", path: "/app/content" },
  { key: "social", label: "Social", icon: "Share2", path: "/app/social" },
  { key: "market", label: "Market Intelligence", icon: "TrendingUp", path: "/app/market" },
  { key: "funds", label: "Fund Research", icon: "LineChart", path: "/app/funds" },
  { key: "regulatory", label: "Regulatory Hub", icon: "ShieldCheck", path: "/app/regulatory" },
  { key: "learn", label: "Learn", icon: "GraduationCap", path: "/app/learn" },
  { key: "community", label: "Community", icon: "MessageSquare", path: "/app/community" },
  { key: "amcs", label: "AMCs", icon: "Building2", path: "/app/amcs" },
  { key: "tools", label: "Tools", icon: "Wrench", path: "/app/tools" },
  { key: "consultants", label: "Consultants", icon: "UserCheck", path: "/app/consultants" },
  { key: "studios", label: "Podcast Studios", icon: "Mic", path: "/app/studios" },
  { key: "website", label: "My Website", icon: "Globe", path: "/app/website" },
  { key: "appointments", label: "Bookings", icon: "CalendarClock", path: "/app/appointments" },
  { key: "wallet", label: "Wallet", icon: "Wallet", path: "/app/wallet" },
  { key: "profile", label: "My Profile", icon: "User", path: "/app/profile" },
];

// Grouped navigation for the sidebar (Digital Operating System structure)
export const NAV_GROUPS = [
  { section: "COMMUNITY", items: [
    { key: "community", label: "Community", icon: "MessageSquare", path: "/app/community" },
    { key: "iap", label: "Investor Awareness", icon: "Megaphone", path: "/app/investor-awareness" },
    { key: "messages", label: "Messages", icon: "MessageCircle", path: "/app/messages" },
    { key: "amcs", label: "AMCs", icon: "Building2", path: "/app/amcs" },
    { key: "consultants", label: "Consultants", icon: "UserCheck", path: "/app/consultants" },
    { key: "studios", label: "Podcast Studios", icon: "Mic", path: "/app/studios" },
  ]},
  { section: "MANAGING BUSINESS", items: [
    { key: "dashboard", label: "Dashboard", icon: "LayoutDashboard", path: "/app/dashboard" },
    { key: "clients", label: "My Clients", icon: "UserSquare2", path: "/app/clients" },
    { key: "leads", label: "Leads", icon: "Target", path: "/app/leads" },
    { key: "crm", label: "CRM Pipeline", icon: "Users", path: "/app/crm" },
    { key: "tasks", label: "Tasks", icon: "ListChecks", path: "/app/tasks" },
    { key: "weekly", label: "Weekly Brief", icon: "CalendarCheck", path: "/app/weekly" },
    { key: "retention", label: "Retention Radar", icon: "Radar", path: "/app/retention" },
    { key: "business", label: "My Business", icon: "BarChart3", path: "/app/business" },
    { key: "marketing", label: "Marketing Factory", icon: "Megaphone", path: "/app/marketing" },
    { key: "content", label: "Content Studio", icon: "PenSquare", path: "/app/content" },
    { key: "publish", label: "MFDx Publish", icon: "Send", path: "/app/publish" },
    { key: "social", label: "Social", icon: "Share2", path: "/app/social" },
    { key: "website", label: "My Website", icon: "Globe", path: "/app/website" },
    { key: "ai", label: "AI Copilot", icon: "Sparkles", path: "/app/ai" },
    { key: "appointments", label: "Bookings", icon: "CalendarClock", path: "/app/appointments" },
    { key: "tools", label: "Calculators", icon: "Wrench", path: "/app/tools" },
    { key: "wallet", label: "Wallet", icon: "Wallet", path: "/app/wallet" },
  ]},
  { section: "LEARNING", items: [
    { key: "learn", label: "Academy & NISM", icon: "GraduationCap", path: "/app/learn" },
    { key: "notebook", label: "Research Notebook", icon: "NotebookPen", path: "/app/notebook" },
    { key: "market", label: "Market Intelligence", icon: "TrendingUp", path: "/app/market" },
    { key: "funds", label: "Fund Research", icon: "LineChart", path: "/app/funds" },
    { key: "regulatory", label: "Regulatory Hub", icon: "ShieldCheck", path: "/app/regulatory" },
  ]},
];

export const MARKET_BRIEF = [
  { title: "Midcaps cooled off", detail: "Nifty Midcap slipped 0.34% while large-caps held firm.", implication: "Reassure aggressive-portfolio clients — this is normal volatility. Reinforce staying invested via SIP.", tone: "amber", icon: "Activity" },
  { title: "IT & Banking led gains", detail: "IT +1.62% and Bank Nifty +1.14% on strong global cues.", implication: "A good moment to highlight the value of diversified flexi-cap exposure to prospects.", tone: "blue", icon: "TrendingUp" },
  { title: "Debt looks attractive", detail: "The 10Y G-Sec eased to 6.84%.", implication: "Conservative and retiree clients may benefit from adding duration / debt allocation.", tone: "violet", icon: "Landmark" },
  { title: "SIP flows at record highs", detail: "Industry SIP book keeps growing month-on-month.", implication: "Reinforce SIP discipline — a powerful, timely story for client conversations.", tone: "lime", icon: "Repeat" },
];

export const MARKET_INDICES = [
  { name: "NIFTY 50", value: "24,318.20", chg: "+0.72%", up: true },
  { name: "SENSEX", value: "79,842.11", chg: "+0.68%", up: true },
  { name: "BANK NIFTY", value: "52,104.55", chg: "+1.14%", up: true },
  { name: "NIFTY IT", value: "43,920.80", chg: "+1.62%", up: true },
  { name: "NIFTY MIDCAP", value: "58,201.30", chg: "-0.34%", up: false },
  { name: "10Y G-SEC", value: "6.84%", chg: "-0.02", up: false },
  { name: "USD/INR", value: "83.42", chg: "+0.11%", up: false },
  { name: "GOLD (10g)", value: "₹73,410", chg: "+0.44%", up: true },
];
export const SECTORS = [
  { name: "IT", chg: 1.62 }, { name: "Banking", chg: 1.14 }, { name: "Auto", chg: 0.82 },
  { name: "Pharma", chg: 0.31 }, { name: "FMCG", chg: -0.18 }, { name: "Metal", chg: -0.74 },
  { name: "Realty", chg: -1.22 }, { name: "Energy", chg: 0.44 },
];
export const RADAR_CATEGORIES = [
  { cat: "Flexi Cap", trend: 2 }, { cat: "Large Cap", trend: 1 }, { cat: "Mid Cap", trend: 1 },
  { cat: "Small Cap", trend: -1 }, { cat: "Debt", trend: 2 }, { cat: "Hybrid", trend: 1 },
  { cat: "ELSS", trend: 1 }, { cat: "Index Funds", trend: 2 },
];
export const RADAR_CITIES = [
  { city: "Mumbai", note: "Flexi Cap & Debt gaining traction", growth: "+8.2%" },
  { city: "Pune", note: "Strong SIP growth among young investors", growth: "+11.4%" },
  { city: "Bengaluru", note: "New investor onboarding surge (tech)", growth: "+9.7%" },
  { city: "Delhi NCR", note: "HNI interest in hybrid & AIFs", growth: "+6.1%" },
];

export const REGULATIONS = [
  { id: 1, source: "SEBI", title: "Streamlining of Nomination facility in Mutual Funds", impact: "Medium", deadline: "28 Aug 2026", summary: "All folios must have nomination or explicit opt-out declaration. Existing folios without either will be frozen for debits.", meaning: "Clients without nomination updated can't redeem until they comply. Proactively help clients complete nomination.", action: ["Identify clients with missing nomination", "Send WhatsApp reminder + form link", "Track completion before deadline"] },
  { id: 2, source: "AMFI", title: "Revised commission disclosure norms for distributors", impact: "High", deadline: "15 Sep 2026", summary: "Enhanced transparency on trail commission disclosure in half-yearly Consolidated Account Statements.", meaning: "No action needed on transactions, but be ready to explain trail structure to clients who ask.", action: ["Read updated disclosure format", "Prepare client-friendly explanation", "Update your website disclosures"] },
  { id: 3, source: "SEBI", title: "Cybersecurity & Cyber Resilience Framework", impact: "Low", deadline: "30 Sep 2026", summary: "Guidelines on data protection and secure client data handling for regulated intermediaries.", meaning: "Review how you store client KYC/data. Use secure, access-controlled systems.", action: ["Audit client data storage", "Enable 2FA on all tools", "Avoid sharing data on unsecured channels"] },
];

const AMC_BANNERS = [
  U("photo-1470075801209-17f9ec0cada6", 900),
  U("photo-1554469384-e58fac16e23a", 900),
  U("photo-1576731753569-3e93a228048c", 900),
  U("photo-1621831337128-35676ca30868", 900),
];
export const AMCS = [
  { name: "Zenith Mutual Fund", aum: "₹4.2 L Cr", view: "Constructive on large-caps; adding duration in debt.", schemes: 42, verified: true, color: "#3B82F6", banner: AMC_BANNERS[0],
    about: "One of India's largest fund houses with a strong equity and fixed-income franchise.",
    managers: [{ n: "R. Krishnan", r: "CIO – Equity" }, { n: "P. Sharma", r: "Head – Fixed Income" }],
    nfos: [{ name: "Zenith Nifty Next 50 Index Fund", status: "Open" }, { name: "Zenith Multi Asset Allocation Fund", status: "Closing soon" }],
    factsheets: [{ fund: "Zenith Flexi Cap Fund", period: "Aug 2026" }, { fund: "Zenith Corporate Bond Fund", period: "Aug 2026" }, { fund: "Zenith ELSS Tax Saver", period: "Aug 2026" }],
    communication: [{ date: "14 Aug 2026", title: "Monthly market outlook & fund positioning" }, { date: "07 Aug 2026", title: "Change in fund manager — Zenith Small Cap" }, { date: "01 Aug 2026", title: "Dividend / IDCW declaration notice" }],
    webinars: [{ title: "Market Outlook 2026 — live with the CIO", date: "22 Aug, 4 PM" }, { title: "SIP strategies for volatile markets", date: "29 Aug, 11 AM" }],
    resources: [{ name: "Product brochure pack", type: "PDF" }, { name: "Client SIP presentation", type: "PPT" }, { name: "Common transaction forms", type: "Forms" }, { name: "Co-branded creatives", type: "Images" }] },
  { name: "Meridian AMC", aum: "₹2.8 L Cr", view: "Cautious on small-caps after the recent rally.", schemes: 38, verified: true, color: "#8B5CF6", banner: AMC_BANNERS[1],
    about: "Known for its research-driven mid and small-cap strategies.",
    managers: [{ n: "A. Kulkarni", r: "Head – Equity" }, { n: "S. Nair", r: "Fund Manager – Large Cap" }],
    nfos: [{ name: "Meridian Business Cycle Fund", status: "Open" }],
    factsheets: [{ fund: "Meridian Midcap Fund", period: "Aug 2026" }, { fund: "Meridian Large Cap Fund", period: "Aug 2026" }, { fund: "Meridian Small Cap Fund", period: "Aug 2026" }],
    communication: [{ date: "13 Aug 2026", title: "Small-cap valuation note for distributors" }, { date: "05 Aug 2026", title: "Revised expense ratio — 2 schemes" }],
    webinars: [{ title: "Decoding mid-cap opportunities", date: "24 Aug, 3 PM" }],
    resources: [{ name: "Fund one-pagers", type: "PDF" }, { name: "Distributor empanelment kit", type: "Forms" }, { name: "Social media creatives", type: "Images" }] },
  { name: "Aarya Asset Mgmt", aum: "₹1.9 L Cr", view: "Overweight financials and manufacturing themes.", schemes: 29, verified: true, color: "#F97316", banner: AMC_BANNERS[2],
    about: "A debt-focused house expanding its hybrid and thematic equity range.",
    managers: [{ n: "V. Rao", r: "CIO – Fixed Income" }, { n: "N. Desai", r: "Fund Manager – Hybrid" }],
    nfos: [{ name: "Aarya Manufacturing Fund", status: "Open" }, { name: "Aarya Banking & PSU Debt Fund", status: "Open" }],
    factsheets: [{ fund: "Aarya Corporate Bond Fund", period: "Aug 2026" }, { fund: "Aarya Short Duration Fund", period: "Aug 2026" }],
    communication: [{ date: "12 Aug 2026", title: "Fixed income strategy — rate cycle view" }, { date: "02 Aug 2026", title: "New scheme information document (SID) filed" }],
    webinars: [{ title: "Why debt deserves a bigger allocation now", date: "27 Aug, 12 PM" }],
    resources: [{ name: "Debt fund explainer deck", type: "PPT" }, { name: "KYC & onboarding forms", type: "Forms" }, { name: "WhatsApp-ready creatives", type: "Images" }] },
  { name: "Sristi Investments", aum: "₹95k Cr", view: "New passive/index NFO launching this month.", schemes: 21, verified: false, color: "#06B6D4", banner: AMC_BANNERS[3],
    about: "A newer, digital-first AMC focused on low-cost index and passive products.",
    managers: [{ n: "K. Iyer", r: "Head – Passive" }],
    nfos: [{ name: "Sristi Nifty 500 Index Fund", status: "Open" }],
    factsheets: [{ fund: "Sristi Nifty 50 Index Fund", period: "Aug 2026" }, { fund: "Sristi Balanced Advantage", period: "Aug 2026" }],
    communication: [{ date: "11 Aug 2026", title: "Index fund tracking error report" }, { date: "03 Aug 2026", title: "NFO launch — Nifty 500 Index Fund" }],
    webinars: [{ title: "Passive investing 101 for your clients", date: "30 Aug, 5 PM" }],
    resources: [{ name: "Index investing brochure", type: "PDF" }, { name: "Cost comparison calculator", type: "Tool" }, { name: "Empanelment form", type: "Forms" }] },
];

export const IMG = {
  advisor: [U("photo-1659355894218-47ead670f7f5"), U("photo-1659355894059-c6b57f5bc8e9"), U("photo-1637589308599-3478cc55510d")],
  marketing: [U("photo-1620313926202-159eb90ec94a"), U("photo-1537731121640-bc1c4aba9b80"), U("photo-1777559542843-cfa96378d89f"), U("photo-1559854036-2409f22a918a")],
  skyline: [U("photo-1785768699591-d0845b8e7478", 1600), U("photo-1770331373157-89d085ed7ea2", 1600)],
};

export const COURSES = [
  { title: "Building a Modern MFD Practice", cat: "Business", lessons: 14, level: "Beginner", color: "#3B82F6", img: IMG.advisor[0] },
  { title: "HNI Client Acquisition Playbook", cat: "Business", lessons: 10, level: "Advanced", color: "#8B5CF6", img: IMG.advisor[1] },
  { title: "Instagram & Reels for MFDs", cat: "Digital", lessons: 12, level: "Beginner", color: "#F97316", img: IMG.marketing[0] },
  { title: "LinkedIn Personal Branding", cat: "Digital", lessons: 9, level: "Intermediate", color: "#06B6D4", img: IMG.marketing[2] },
  { title: "AUM & Revenue Analytics", cat: "Analytics", lessons: 8, level: "Intermediate", color: "#A3E635", img: IMG.marketing[1] },
  { title: "SEBI & AMFI Compliance Essentials", cat: "Compliance", lessons: 11, level: "All levels", color: "#4F46E5", img: IMG.advisor[2] },
];

export const AVATARS = [
  U("photo-1607990283143-e81e7a2c9349", 200),
  U("photo-1580489944761-15a19d654956", 200),
  U("photo-1507003211169-0a1dd7228f2d", 200),
  U("photo-1494790108377-be9c29b29330", 200),
  "https://images.pexels.com/photos/12311572/pexels-photo-12311572.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200",
  "https://images.pexels.com/photos/37148308/pexels-photo-37148308.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200",
];
export const avatarFor = (name = "") => {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return AVATARS[h % AVATARS.length];
};

export const CONSULTANTS = [
  { name: "Ananya Rao", role: "Digital Marketing Expert", rating: 4.9, reviews: 128, exp: "9 yrs", tags: ["Meta Ads", "Content", "Funnels"], img: AVATARS[0] },
  { name: "Karan Malhotra", role: "SEO & Google Business Expert", rating: 4.8, reviews: 96, exp: "7 yrs", tags: ["SEO", "GBP", "Local"], img: AVATARS[2] },
  { name: "Divya Menon", role: "Branding Consultant", rating: 5.0, reviews: 74, exp: "11 yrs", tags: ["Identity", "Positioning"], img: AVATARS[1] },
  { name: "Rahul Bose", role: "Video Creator", rating: 4.7, reviews: 152, exp: "6 yrs", tags: ["Reels", "Explainers"], img: AVATARS[5] },
  { name: "Sana Kapoor", role: "CRM & Automation Consultant", rating: 4.9, reviews: 63, exp: "8 yrs", tags: ["CRM", "Workflows"], img: AVATARS[3] },
  { name: "Vivek Nanda", role: "AI Consultant", rating: 4.8, reviews: 88, exp: "5 yrs", tags: ["AI", "Prompting"], img: AVATARS[4] },
];
export const CONSULT_PRICING = [{ d: "15 min", p: 199 }, { d: "30 min", p: 399 }, { d: "60 min", p: 699 }];

export const AI_PROMPTS = [
  "Which clients should I call today?",
  "Draft a WhatsApp message for my SIP clients.",
  "Why did my AUM fall this month?",
  "Give me 10 leads I should follow up with.",
  "Explain today's market movement to a retail investor.",
  "Create a LinkedIn post on today's market.",
  "Summarise today's SEBI circular.",
  "Prepare my client review meeting.",
];

// Context-aware Copilot suggestions — shown based on the section the user came from.
export const AI_PROMPTS_BY_CONTEXT = {
  business: AI_PROMPTS,
  community: [
    "Draft a post to introduce myself to the MFD community.",
    "Suggest a discussion topic that gets MFDs talking.",
    "Summarise what MFDs are discussing this week.",
    "Write a helpful reply to a peer's question on SIP drop-offs.",
    "Which community events should I attend this month?",
    "Give me ice-breakers to network with other MFDs.",
  ],
  learn: [
    "Explain SIP vs lumpsum in simple terms.",
    "Quiz me on NISM Series V-A basics.",
    "What topics should I study to clear my NISM exam?",
    "Explain expense ratio and how it affects returns.",
    "Break down today's market movement so I can learn from it.",
    "Summarise the latest SEBI circular for my understanding.",
  ],
};

export const CRM_STAGES = ["Lead", "Contacted", "Meeting", "Proposal", "Invested", "Active Client"];

const STUDIO_IMGS = [
  "https://images.unsplash.com/photo-1660631228116-b3643559f611?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  "https://images.unsplash.com/photo-1589903308904-1010c2294adc?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  "https://images.unsplash.com/photo-1531651008558-ed1740375b39?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
  "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
];
export const STUDIO_CITIES = ["All", "Mumbai", "Pune", "Bengaluru", "Delhi NCR", "Hyderabad", "Chennai"];
export const PODCAST_STUDIOS = [
  { name: "SoundForge Studios", city: "Mumbai", area: "Andheri West", price: 1200, rating: 4.8, reviews: 214, img: STUDIO_IMGS[2], amenities: ["4K video", "Soundproof", "3 mics", "Editor on request"] },
  { name: "WaveHouse", city: "Pune", area: "Koregaon Park", price: 900, rating: 4.7, reviews: 138, img: STUDIO_IMGS[1], amenities: ["1080p video", "Soundproof", "2 mics", "Lighting kit"] },
  { name: "EchoLab", city: "Bengaluru", area: "Indiranagar", price: 1100, rating: 4.9, reviews: 176, img: STUDIO_IMGS[0], amenities: ["4K video", "Acoustic panels", "4 mics", "Teleprompter"] },
  { name: "MicDrop Studio", city: "Delhi NCR", area: "Hauz Khas", price: 1000, rating: 4.6, reviews: 121, img: STUDIO_IMGS[3], amenities: ["4K video", "Soundproof", "2 mics", "Green screen"] },
  { name: "Resonance Rooms", city: "Hyderabad", area: "Jubilee Hills", price: 850, rating: 4.7, reviews: 92, img: STUDIO_IMGS[1], amenities: ["1080p video", "Acoustic panels", "2 mics", "Editor on request"] },
  { name: "StudioBlue", city: "Chennai", area: "Nungambakkam", price: 800, rating: 4.5, reviews: 84, img: STUDIO_IMGS[2], amenities: ["1080p video", "Soundproof", "2 mics", "Lighting kit"] },
];


export const MODULES_12 = [
  { t: "AI Assistant", d: "Your business co-pilot", icon: "Sparkles", c: "#3B82F6" },
  { t: "CRM", d: "Leads to loyal clients", icon: "Users", c: "#8B5CF6" },
  { t: "Marketing Studio", d: "Create in seconds", icon: "Megaphone", c: "#F97316" },
  { t: "Market Radar", d: "What's selling where", icon: "Radar", c: "#06B6D4" },
  { t: "Regulatory Hub", d: "SEBI & AMFI decoded", icon: "ShieldCheck", c: "#4F46E5" },
  { t: "Community", d: "100,000 MFDs", icon: "MessageSquare", c: "#A3E635" },
  { t: "Academy", d: "Grow your skills", icon: "GraduationCap", c: "#3B82F6" },
  { t: "AMC Hub", d: "Talk to AMCs", icon: "Building2", c: "#8B5CF6" },
  { t: "Google Business", d: "Get found on Google", icon: "MapPin", c: "#F97316" },
  { t: "Wallet", d: "Pay as you use", icon: "Wallet", c: "#06B6D4" },
  { t: "Consultants", d: "Book an expert", icon: "UserCheck", c: "#4F46E5" },
  { t: "Analytics", d: "Business intelligence", icon: "BarChart3", c: "#A3E635" },
];
